import React from "react";
import "./HomePage.css";

export default function HomePage() {
  return (
    <>
      <h2 className="home">Home</h2>
      <p className="intro">Welcome to THE MOVIE CATCHER</p>
    </>
  );
}
